import { useQuery } from "@tanstack/react-query";
import {
	GET_COMPETENCY_CORE_SKILL,
	GET_COMPETENCY_TECHNICAL_SKILL,
	GET_COMPETENCY_SKILL_LEVELS,
} from "../../keys";
import {
	getCompetencyCoreSkillDetail,
	getCompetencyTechnicalSkillDetail,
	getCompetencyLevels,
} from "@onair/services/lms";

export const useGetCompetencyTechnicalSkillId = (options: {
	id?: number;
	enabled?: boolean;
}) => {
	const { id, enabled = true } = options;
	return useQuery({
		queryKey: [GET_COMPETENCY_TECHNICAL_SKILL, id],
		queryFn: () => getCompetencyTechnicalSkillDetail(id),
		enabled,
	});
};

export const useGetCompetencyCoreSkillId = (options: {
	id?: number;
	enabled?: boolean;
}) => {
	const { id, enabled = true } = options;
	return useQuery({
		queryKey: [GET_COMPETENCY_CORE_SKILL, id],
		queryFn: () => getCompetencyCoreSkillDetail(id),
		enabled,
	});
};

export const useGetCompetencySkillLevels = (options: { enabled?: boolean }) => {
	const { enabled = true } = options;
	return useQuery({
		queryKey: [GET_COMPETENCY_SKILL_LEVELS],
		queryFn: getCompetencyLevels,
		enabled,
	});
};
